import React from 'react'
import { Route } from 'react-router-dom'
import AuthAppSuccess from './AuthAppSuccess';

import { authAppSuccess } from "../../../constants/routePaths"

const AuthAppSuccessRoute = [
  <Route
    key="AuthAppSuccess"
    exact path={authAppSuccess}
    component={AuthAppSuccess}
  />,
];

export default AuthAppSuccessRoute
